import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom'; 
import { useSelector, useDispatch } from 'react-redux';
import { fetchSlides } from '../actions/SlidesActions';
import '../styles/imageslider.css'; 
import { useImage } from '../contexts/ImageContext';
import { HomeHeroSkeleton } from "./HomeSkeletons";



const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const [slideDirection, setSlideDirection] = useState('');
  const navigate = useNavigate(); 
  const dispatch = useDispatch();
  const { slides, loading, error } = useSelector((state) => state.slides);
  const { getImageUrl } = useImage();
  
  useEffect(() => {
    dispatch(fetchSlides());
  }, [dispatch]);

  useEffect(() => {
    if (slides && slides.length > 0) {
      setPrevIndex(currentIndex === 0 ? slides.length - 1 : currentIndex - 1);
      setNextIndex(currentIndex === slides.length - 1 ? 0 : currentIndex + 1);
    }
  }, [slides, currentIndex]);

  useEffect(() => {
    let interval;
    
    if (isPlaying && !isHovered && slides && slides.length > 0) {
      interval = setInterval(() => {
        goToNext();
      }, 3000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isHovered, isPlaying, currentIndex, slides]);

  const goToPrevious = () => {
    if (!slides || slides.length === 0) return;
    
    setSlideDirection('prev');
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
    setTimeout(() => setSlideDirection(''), 800);
  };

  const goToNext = () => {
    if (!slides || slides.length === 0) return;
    
    setSlideDirection('next');
    setCurrentIndex((prevIndex) =>
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
    setTimeout(() => setSlideDirection(''), 800);
  };
  
  const navigateToProduct = (slide, e) => {
    if (e) e.stopPropagation();
    try {
      const url = new URL(slide.link);
      navigate(url.pathname);
    } catch (error) {
      navigate("/productspage");
    }
  };

  if (loading) return <HomeHeroSkeleton />;
  if (error)
    return <div className="slider error">Error loading slides: {error}</div>;
  if (!slides || slides.length === 0) {
    return <div className="slider slider-placeholder" aria-hidden="true" />;
  }

  const visibleSlides = [
    { slide: slides[prevIndex], position: 'prev' },
    { slide: slides[currentIndex], position: 'active' },
    { slide: slides[nextIndex], position: 'next' }
  ];

  return (
    <div
      className={`slider ${slideDirection}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {visibleSlides.map(({ slide, position }) => (
        <div
          key={`${slide.slide_id}-${position}`}
          onClick={() => {
            try {
              const url = new URL(slide.link);
              navigate(url.pathname);
            } catch (error) {
              navigate("/productspage");
            }
          }}
          className={`slide ${position}`}
          style={{ backgroundImage: `url(${getImageUrl(slide.image)})` }}
        >
          <div className="slider-content">
            <span className="slider-tag">{slide.slug}</span>
            <h2>{slide.title}</h2>
            <p>{slide.description}</p>
            <button 
              className="shop-now-btn" 
              onClick={(e) => navigateToProduct(slide, e)}
            >
              shop now
            </button>
          </div>
        </div>
      ))}

      <div className="slider-controls">
        <button className="arrow-btn" onClick={goToPrevious}>‹</button>
        <div className="slide-counter">{currentIndex + 1} / {slides.length}</div>
        <button className="arrow-btn" onClick={goToNext}>›</button>
        <button className="play-pause-btn" onClick={() => setIsPlaying(!isPlaying)}>
          {isPlaying ? "II" : "▶"}
        </button>
      </div>
    </div>
  );
};

export default ImageSlider;
